<template>
  <div class="page-about">
    <div class="tit">合作</div>
    <div class="map">
      <img :src="require('@/assets/images/about_map.png')" alt="" />
    </div>
    <div class="contact-list clearfix">
      <div class="item">
        <div class="c-tit">大V入驻</div>
        <div class="c-user">联系人：樊晓东</div>
        <div class="c-email">邮箱：fanxiaodong@21teacher.com</div>
        <div class="c-wechat">微信号：feixuhudie24</div>
      </div>
      <div class="item">
        <div class="c-tit">机构合作</div>
        <div class="c-user">联系人：魏晶雨</div>
        <div class="c-email">邮箱：weijingyu@21teacher.com</div>
        <div class="c-wechat">微信号：laomaozuiying</div>
      </div>
      <div class="item">
        <div class="c-tit">学校合作</div>
        <div class="c-user">联系人：樊晓东</div>
        <div class="c-email">邮箱：fanxiaodong@21teacher.com</div>
        <div class="c-wechat">微信号：feixuhudie24</div>
      </div>
      <div class="item">
        <div class="c-tit">版权合作</div>
        <div class="c-user">联系人：陈江武</div>
        <div class="c-email">邮箱：chenjiangwu@21teacher.com</div>
        <div class="c-wechat">电话：15652761276</div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import updateTdk from "@/utils/tdk";
export default {
  name:"coop",
  components: {

  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  data () {
    return {
      headTitle: "人人动画网【官网】",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false //for control not ssr render
    }
  },
  serverPrefetch() {
    this.setSeo();
    updateTdk.call(this);
  },
  mounted() {
    this.isMounted = true;

  },
  beforeRouteUpdate(to, from, next) {
    // 一般建议路由变更采用计算属性或者store直接绑定
    // 特殊情况处理可以采用如下方案 重新注册数据返回处理
    next();
  },
  methods:{
    setSeo() {
      this.headTitle = "合作——人人动画网【官网】";
      this.headKeywords = "人人动画网合作,院校合作,机构合作";
      this.headDesc =
              "人人动画网，是一个动画短视频分享社区，欢迎大V、学校、机构等社会精英与我们洽谈合作事项。";
    },
  }
}
</script>

<style scoped lang="less">
.page-about {
  padding-top: @NAVHEIGHT + 30;
  padding-bottom: 50px;
  .tit {
    padding: 5px 0 20px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    letter-spacing: 10px;
  }
  .map {
    margin: 0 auto;
    width: 1200px;
    img {
      display: block;
      width: 100%;
    }
  }
  .contact-list {
    margin: 30px auto 0;
    padding: 0 50px;
    width: 1200px;
    .item {
      float: left;
      margin-bottom: 20px;
      width: 50%;
      font-size: 16px;
      .c-tit {
        margin-bottom: 15px;
        font-size: 18px;
        font-weight: bold;
      }
      .c-user,
      .c-email,
      .c-wechat {
        margin-top: 8px;
      }
    }
  }
}
@media screen and (max-width: 1024px) {
  .page-about {
    padding-top: @NAVHEIGHT + 10;
    padding-bottom: 10px;
    .map {
      width: 100%;
    }
    .contact-list {
      margin-top: 10px;
      padding: 0 20px;
      width: 100%;
      .item {
        float: none;
        margin-bottom: 20px;
        width: 100%;
        &:last-child {
          margin-bottom: 0;
        }
        .c-tit {
          margin-bottom: 5px;
        }
      }
    }
  }
}
</style>
